jQuery(document).ready(function ($) {
    $('#startDate').flatpickr(
        {
            allowInput: true,
            enableTime: true,
            dateFormat: "m/d/Y H:i",
            disableMobile: true
        });
    $('#endDate').flatpickr(
        {
            allowInput: true,
            enableTime: true,
            dateFormat: "m/d/Y H:i",
            disableMobile: true
        });

    for (i = 0; i <= 10; i++) {
        $("#affiliateContestPrize"+i).keyup(function () {
            if (this.value != this.value.replace(/[^0-9\.]/g, '')) {
                this.value = this.value.replace(/[^0-9\.]/g, '');
            }
        });
    }

    //Logic for hiding/showing prize entry. Clears hidden fields.
    $('#affiliateContestWinnersCount').change(function(){
        for (i = 0; i <= $(this).val(); i++) {
            $("#affiliateContestPrizeId"+i).show();
        }
        for (i = 10; i > $(this).val(); i--) {
            $("#affiliateContestPrizeId"+i).hide();
            $("#affiliateContestPrize"+i).val("");
        }
    }).change();

    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'header': [1, 2, 3, 4, false] }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'color': [] }, { 'background': [] }],
        ['link'],
        ['image']
    ];

    const termsAndConditions = $('#wysiwyg-terms-and-conditions');
    const termsAndConditionsHTML = termsAndConditions.html();

    termsAndConditions.text('').append(termsAndConditionsHTML)

    var quill = new Quill('#wysiwyg-terms-and-conditions', {
        modules: {
            toolbar: {
                container:toolbarOptions,
                handlers: {
                    image: imageHandler
                }
            },
        },
        placeholder: 'Add Terms And Conditions',
        theme: 'snow'
    });
    function imageHandler() {
        var range = this.quill.getSelection();
        var value = prompt('please copy paste the image url here.');
        if(value){
            this.quill.insertEmbed(range.index, 'image', value, Quill.sources.USER);
        }
    }

    //Update all hidden values when submitting
    $('#affiliateContestForm').on('submit',function() {
        const termsAndConditions = $('#wysiwyg-terms-and-conditions').children('.ql-editor').html();
        $("input[name^='termsAndConditions']").val(termsAndConditions);
    })

    //Set the update interval for the live leaderboard. Refresh every 30 seconds. If the refresh flag isn't set,
    //then the contest has expired and the data should not be refreshed.
    if(shouldRefresh) {
        var interval = setInterval(function () {
            updatePositions();
            updateTotals();
            updateLatestSales();
        }, 30000)
    }
});

//Call the live_updates_route to retrieve the twig data needed to reload the live leaderboard component.
function updatePositions() {
    $.get(live_updates_route, function(data) {
        $("#contests-wrapper-js").html(data);
    });
}

function updateTotals() {
    $.get(live_totals_route, function(data) {
        $("#totals-wrapper-js").html(data);
    });
}

function updateLatestSales() {
    $.get(live_sales_route, function(data) {
        $("#latestsales-wrapper-js").html(data);
    });
}
